import departments from './departments/departmentsSlice';
import staff from './staff/staffSlice';

const root = {
	departments,
	staff
};

export default root;
